// 越南语
export const Vietnamese = {
  language_code: "vi",
  get_btn: "Nhận ngay",
  unregistered_tip: "Người dùng chưa đăng ký sẽ tạo tài khoản trực tiếp.",
  phone_number: "Số điện thoại",
  ver_code: "Mã xác minh",
  get_ver_code: "Nhận mã",
  retrieve_ver_code: "Lấy lại ({SECONDS})",
  age_tip:
    "Tôi đã đủ tuổi trưởng thành và có đầy đủ năng lực hành vi dân sự, đồng ý với ",
  and: " và ",
  PRIVICY_POLICY: '"Chính sách bảo mật"',
  MEMBER_AGGREMENT: '"Điều khoản thành viên"',
  agree_push:
    "Tôi đồng ý nhận thông báo từ Haidilao qua số điện thoại hoặc email đã đăng ký.",
  CN: "Trung Quốc",
  US: "Hoa Kỳ",
  CA: "Canada",
  GB: "Vương quốc Anh",
  MY: "Malaysia",
  AU: "Úc",
  ID: "Indonesia",
  SG: "Singapore",
  TH: "Thái Lan",
  JP: "Nhật Bản",
  KR: "Hàn Quốc",
  VN: "Việt Nam",
  HK: "Hồng Kông",
  MO: "Ma Cao",
  HKM: "Campuchia",
  TW: "Đài Loan",
  PH: "Philippines",
  UAE: "UAE",
  suc_send: "Gửi thành công",
  suc_get: "Đổi thành công",
  fail_ver_code: "Mã không đúng",
  time_end: "Sự kiện đã kết thúc",
  not_get_repeat: "Không thể nhận thêm lần nữa!",
  not_get_eligible: "Không thể nhận, không đủ điều kiện cho sự kiện.",
  not_get_late: "Bạn chậm một bước, sự kiện đã kết thúc.",
  get_coupon: "Nhận mã",
  phone_err: "Số điện thoại không hợp lệ. Vui lòng nhập số điện thoại đúng.",
  page_title: "Nhận phiếu giảm giá đặc biệt của Haidilao",
  send_code_error: "Gửi mã xác minh thất bại",
  network_error:
    "Kết nối mạng của bạn hiện đang gặp sự cố, vui lòng thử lại sau.",
  member_status_abnormal: "Tài khoản thành viên gặp sự cố, không thể nhận được",
  send_frequently:
    "Đã gửi quá nhiều mã xác nhận. Nhập mã cuối cùng bạn nhận được hoặc thử lại sau.",
  activity_boom: "Đã có quá nhiều người nhận, vui lòng thử lại sau.",
  email: "Email",
  email_error_tip: "Email không hợp lệ. Vui lòng nhập địa chỉ email đúng.",
  suc_get_dialog_text:
    "Mở ứng dụng thành viên Haidilao ngay để xem phiếu giảm giá đã nhận!",
  btn_sure: "OK",
  btn_cancel: "Hủy",
  suc_dialog_text:
    "Mở ứng dụng Haidilao hoặc liên kết thành viên trên LINE để xem phiếu giảm giá đã nhận!",
  btn_return: "Quay lại",
  btn_download: "Tải xuống",
};
